<script>
export default {}
</script>

<template>
	<div class="card">
		<div class="card-body">
			<slot></slot>
		</div>
	</div>
</template>